import dbsService from "@/services/dbs";

// x-bks-sessionid必須
export const postDbsUnlock = async (params) => {
  try {
    await dbsService.apiWithSessionIdWrapper("POST", `dbs/unlock`, params);
  } catch (err) {
    console.log('ERROR"" postDbsUnlock()');
    throw err;
  }
};
